import React, { useEffect, useState } from 'react';
import { SITE_FILTER_NONE } from '../../Pages/BlogArticlesAdmin/BlogArticlesAdmin.types';
const inputClassName = 'h-9 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-900 placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200';
const Field = ({ label, htmlFor, className, children }) => {
    return (React.createElement("div", { className: className },
        React.createElement("label", { htmlFor: htmlFor, className: "mb-1 block text-xs font-semibold text-gray-600" }, label),
        children));
};
const BlogArticleListFilters = ({ filters, sites, statuses, categories, onApply, onClear }) => {
    const [draft, setDraft] = useState(filters);
    useEffect(() => {
        setDraft(filters);
    }, [filters]);
    const update = (field) => {
        return (event) => {
            setDraft(Object.assign(Object.assign({}, draft), { [field]: event.target.value }));
        };
    };
    return (React.createElement("form", { onSubmit: (event) => {
            event.preventDefault();
            onApply(draft);
        }, className: "flex flex-wrap items-end gap-3 rounded-lg border border-gray-200 bg-white p-3" },
        React.createElement(Field, { label: "Title", htmlFor: "blog-filter-title", className: "w-56" },
            React.createElement("input", { id: "blog-filter-title", type: "search", value: draft.title, onChange: update('title'), placeholder: "Article title", className: inputClassName })),
        React.createElement(Field, { label: "Author", htmlFor: "blog-filter-author", className: "w-44" },
            React.createElement("input", { id: "blog-filter-author", type: "search", value: draft.author, onChange: update('author'), placeholder: "Author name", className: inputClassName })),
        React.createElement(Field, { label: "Site", htmlFor: "blog-filter-site", className: "w-44" },
            React.createElement("select", { id: "blog-filter-site", value: draft.site, onChange: update('site'), className: inputClassName },
                React.createElement("option", { value: "" }, "All"),
                React.createElement("option", { value: SITE_FILTER_NONE }, "No sites"),
                sites.map((site) => {
                    return (React.createElement("option", { key: site.siteCode, value: site.siteCode },
                        site.siteCode,
                        " (",
                        site.name,
                        ")"));
                }))),
        React.createElement(Field, { label: "Status", htmlFor: "blog-filter-status", className: "w-36" },
            React.createElement("select", { id: "blog-filter-status", value: draft.blogArticleStatus, onChange: update('blogArticleStatus'), className: inputClassName },
                React.createElement("option", { value: "" }, "All"),
                statuses.map((status) => {
                    return (React.createElement("option", { key: status.code, value: status.code }, status.name));
                }))),
        React.createElement(Field, { label: "Category", htmlFor: "blog-filter-category", className: "w-48" },
            React.createElement("select", { id: "blog-filter-category", value: draft.blogCategory, onChange: update('blogCategory'), className: inputClassName },
                React.createElement("option", { value: "" }, "All"),
                categories.map((category) => {
                    return (React.createElement("option", { key: category.id, value: String(category.id) }, category.label));
                }))),
        React.createElement("div", { className: "flex gap-2" },
            React.createElement("button", { type: "submit", className: "h-9 rounded-md bg-blue-600 px-4 text-sm font-semibold text-white hover:bg-blue-700" }, "Filter"),
            React.createElement("button", { type: "button", onClick: onClear, className: "h-9 rounded-md border border-gray-300 bg-white px-4 text-sm font-semibold text-gray-700 hover:bg-gray-50" }, "Clear"))));
};
export default BlogArticleListFilters;
